import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { Field } from 'formik';
import { values } from 'lodash';
import { getErrorClass } from '../../../../../utils/errorUtils';
export const OtherDetailsForm = ({ handleChange, handleBlur, values, errors, touched, cityOptions }) => (
  <div className="signite-form">
    <Row className="mb-3">
      <BSForm.Group as={Col} controlId="nativeLocation">
        <BSForm.Label>Native Location</BSForm.Label>
        <BSForm.Select
          name="nativeLocation"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.nativeLocation}
          className={`form-control ${getErrorClass(errors, touched, 'nativeLocation')}`}
        >
          <option value="">Select a city</option>
          {cityOptions.map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </BSForm.Select>
        <span className="errorMessage">{_.get(errors, 'nativeLocation')}</span>
      </BSForm.Group>
      <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
      <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
    </Row>
    <Row className="mb-3">
      <BSForm.Label>Are you willing to relocate?*</BSForm.Label>
      <BSForm.Group as={Col}>
        <div className="form-check form-check-inline">
          <Field type="radio" name="willingToRelocate" value="Yes" className="form-check-input" />
          <label for="willingToRelocate" className="form-check-label">
            Yes
          </label>
        </div>
        <div className="form-check form-check-inline">
          <Field type="radio" name="willingToRelocate" value="No" className="form-check-input" />
          <label for="willingToRelocate" className="form-check-label">
            No
          </label>
        </div>
      </BSForm.Group>
      <BSForm.Group as={Col} controlId="blank"></BSForm.Group>

      <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
    </Row>

    <Row>
      <BSForm.Group as={Col}>
        <BSForm.Label>Location Preference 1</BSForm.Label>
        <BSForm.Select
          name="locationPref1"
          onChange={handleChange}
          value={values.locationPref1}
        >
          <option value="">Select a city</option>
          {cityOptions.map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </BSForm.Select>
      </BSForm.Group>
      <BSForm.Group as={Col}>
        <BSForm.Label>Location Preference 2</BSForm.Label>
        <BSForm.Select
          name="locationPref2"
          onChange={handleChange}
          value={values.locationPref2}
        >
          <option value="">Select a city</option>
          {cityOptions.map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </BSForm.Select>
      </BSForm.Group>
      <BSForm.Group as={Col}>
        <BSForm.Label>Location Preference 3</BSForm.Label>
        <BSForm.Select
          name="locationPref3"
          onChange={handleChange}
          value={values.locationPref3}
        >
          <option value="">Select a city</option>
          {cityOptions.map((city) => (
            <option key={city} value={city}>{city}</option>
          ))}
        </BSForm.Select>
      </BSForm.Group>
    </Row>


    <Row>
      <BSForm.Group as={Col}>
        <BSForm.Label>Open 6 days?*</BSForm.Label>
        <BSForm.Group as={Col}>
          <div className="form-check form-check-inline">
            <Field type="radio" name="openFor6DayWorkWeek" value="Yes" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="radio" name="openFor6DayWorkWeek" value="No" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              No
            </label>
          </div>
        </BSForm.Group>
      </BSForm.Group>
      <BSForm.Group as={Col}>
        <BSForm.Label>Are you willing to travel for work ?*</BSForm.Label>
        <BSForm.Group as={Col}>
          <div className="form-check form-check-inline">
            <Field type="radio" name="willingToTravelForWork" value="Yes" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              Yes
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="radio" name="willingToTravelForWork" value="No" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              No
            </label>
          </div>
        </BSForm.Group>
      </BSForm.Group>
      <BSForm.Group as={Col}>
        <BSForm.Label>What type of job types are you open to ?*</BSForm.Label>
        <BSForm.Group as={Col}>
          <div className="form-check form-check-inline">
            <Field type="checkbox" name="jobTypePreference" value="ON_SITE" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              Onsite
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="checkbox" name="jobTypePreference" value="HYBRID" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              Hybrid
            </label>
          </div>
          <div className="form-check form-check-inline">
            <Field type="checkbox" name="jobTypePreference" value="REMOTE" className="form-check-input" />
            <label for="willingToRelocate" className="form-check-label">
              Remote
            </label>
          </div>
        </BSForm.Group>
      </BSForm.Group>
    </Row>
  </div>
);
